module.exports = __webpack_public_path__ + "2734e0cc60971b704d02ae2ae6153e0b.ttf";